import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request interceptor to add CSRF token
api.interceptors.request.use((config) => {
  const token = document.cookie
    .split('; ')
    .find(row => row.startsWith('XSRF-TOKEN='))
    ?.split('=')[1];

  if (token) {
    config.headers['X-XSRF-TOKEN'] = decodeURIComponent(token);
  }

  return config;
});

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Extract Laravel validation error messages
    if (error.response?.status === 422 && error.response?.data?.errors) {
      // Get the first validation error message
      const errors = error.response.data.errors;
      const firstFieldErrors = Object.values(errors)[0];
      const errorMessage = Array.isArray(firstFieldErrors)
        ? firstFieldErrors[0]
        : error.response.data.message || 'Validation failed';

      // Attach readable message to error object
      error.message = errorMessage;
    } else if (error.response?.data?.message) {
      // Use Laravel's message if available
      error.message = error.response.data.message;
    }

    // Don't automatically redirect on 401
    // Let the app's routing (ProtectedRoute/GuestRoute) handle authentication
    // The auth store will handle updating isAuthenticated state
    return Promise.reject(error);
  }
);

// Get CSRF cookie from Laravel Sanctum
export const getCsrfCookie = async () => {
  await api.get('/sanctum/csrf-cookie');
};

export default api;
